import React from 'react';

import './Scrim.scss';

interface YatScrimProps {
    onClick?: (e: React.MouseEvent<HTMLElement>) => void;
}

export const YatScrim = ({ onClick }: YatScrimProps) => {
    return <div className="yat-scrim" onClick={onClick} tabIndex={-1} />;
};
